/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ branches: NonNullable<unknown>, stores: NonNullable<unknown> }} Shop_Home_Count_StoresInputs */

const vi_shop_home_count_stores = /** @type {(inputs: Shop_Home_Count_StoresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.branches} chi nhánh · ${i?.stores} cửa hàng`)
};

/**

* @param {Shop_Home_Count_StoresInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_count_stores = /** @type {((inputs: Shop_Home_Count_StoresInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Count_StoresInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_count_stores(inputs)
});